import google from "./home/trustedBrands/google.jpg";
import bark from "./home/trustedBrands/bark.jpg";
import clutch from "./home/trustedBrands/clutch.jpg";
import GoodFirm from "./home/trustedBrands/GoodFirm.jpg";
import sortist from "./home/trustedBrands/sortist.jpg";
import company1 from "./home/trustedBrands/Google-Partners.jpg";
import company2 from "./home/trustedBrands/Shopify-Partners.jpg";
import company3 from "./home/trustedBrands/Bing-ads.jpg";
import company4 from "./home/trustedBrands/techimply.jpg";
import company5 from "./home/trustedBrands/BNI-Connect.jpg";
import company6 from "./home/trustedBrands/gesia.jpg";
import company7 from "./home/trustedBrands/Business.jpg";
import company8 from "./home/trustedBrands/Meta.jpg";
import company10 from "./home/trustedBrands/yourStory.jpg";
import work1 from "./home/Work/FirstWork.jpg";
import work2 from "./home/Work/SecondWork.jpg";
import work3 from "./home/Work/ThirdWork.jpg";
import work4 from "./home/Work/FourthWork.jpg";
import work5 from "./home/Work/FifthWork.jpg";
import work6 from "./home/Work/SixthWork.jpg";
import certificate1 from "./home/Certificates/certificates1.jpg";
import certificate2 from "./home/Certificates/certificates2.jpg";
import certificate3 from "./home/Certificates/certificates3.jpg";
import certificate4 from "./home/Certificates/certificates4.jpg";
import certificate5 from "./home/Certificates/certificates5.webp";
import certificate6 from "./home/Certificates/certificates6.jpg";
import certificate7 from "./home/Certificates/certificates7.jpg";
import career from "./Career/career.webp";
import hero_1 from "./AboutUs/hero/hero_1.webp";
import hero_2 from "./AboutUs/hero/hero_2.webp";
import hero_3 from "./AboutUs/hero/hero_3.webp";
import client_1 from './AboutUs/client/client1.png';
import client_2 from './AboutUs/client/client2.png';
import client_3 from './AboutUs/client/client3.png';
import client_4 from './AboutUs/client/client4.png';
import client_5 from './AboutUs/client/client5.png';
import client_6 from './AboutUs/client/client6.png';
import client_7 from './AboutUs/client/client7.png';
import client_8 from './AboutUs/client/client8.png';
import icon1 from "./Career/first_icon.webp";
import icon2 from "./Career/second-icon.webp";
import icon3 from "./Career/third-icon.webp";
import icon4 from "./Career/fourth-icon.webp";
import icon5 from "./Career/fifth-icon.webp";
import icon6 from "./Career/sixth-icon.webp";
import memory1 from "./Career/Memory/Memory1.webp";
import memory2 from "./Career/Memory/MemoryTwo.webp";
import memory3 from "./Career/Memory/MemoryThree.webp";
import memory4 from "./Career/Memory/MmeoryFour.webp";
import memory5 from "./Career/Memory/MemoryFive.webp";
import memory6 from "./Career/Memory/MemorySix.webp";
import memory7 from "./Career/Memory/Memory7.webp";
import webHero from "./services/webdevelopment/HeroImage.webp";
import img1 from "./services/webdevelopment/logo.webp";
import img2 from "./services/webdevelopment/social.webp";
import img3 from "./services/webdevelopment/video.webp";
import img4 from "./services/webdevelopment/Vector.webp";
import img5 from "./services/webdevelopment/ppt.webp";
import img6 from "./services/webdevelopment/Motion.webp";
import contactUs from "./ContactUs/contact-us.jpg";
import blog from "./Blog/gathering-home.jpg";
import portfolioBg from "../images/Portfolio/portfolio_bg.png";
import Project1 from "../images/Portfolio/Project1.jpg";
import Project2 from "../images/Portfolio/Project2.webp";
import Project3 from "../images/Portfolio/Project3.webp";
import applicationBg from "../images/Portfolio/RecentsProject/ApplicationBg.png";
import portfolioBackground from "../images/Portfolio/RecentsProject/PortfolioBg.jpg";
import application1 from "../images/Portfolio/RecentsProject/application1.webp";
import application2 from "../images/Portfolio/RecentsProject/application2.webp";
import application3 from "../images/Portfolio/RecentsProject/application3.webp";
import Header from "./header/Header.png";
import Footer from "./header/Footer2.png";
import WebProject1 from "./Portfolio/WebApp/Varn.png";
import WebProject2 from "./Portfolio/WebApp/Coffee.png";
import WebProject3 from "./Portfolio/WebApp/Gradexresult.png";
import AppProject1 from "./Portfolio/ApplicationDevelopment/FoodApp.png";
import AppProject2 from "./Portfolio/ApplicationDevelopment/Coffee.png";
import AppProject3 from "./Portfolio/ApplicationDevelopment/AsitField.png";
import NymbleUp1 from "./Portfolio/ApplicationDevelopment/NymbleUp1.png";
import NymbleUp2 from "./Portfolio/ApplicationDevelopment/NymblePy2.png";
import NymbleUp3 from "./Portfolio/ApplicationDevelopment/NymblePy3.png";
import FarmHouseHub from "./Portfolio/ApplicationDevelopment/FarmHouseHub.png";
import EasyGym from "./Portfolio/ApplicationDevelopment/EasyGym.png";
import GenieDelivery from "./Portfolio/ApplicationDevelopment/GenieDelivery.png";
import OneVision from "./Portfolio/ApplicationDevelopment/OneVision.png";
import Efone from "./Portfolio/ApplicationDevelopment/Efone.png";
import AsitField2 from "./Portfolio/ApplicationDevelopment/AsitField2.png";
import AsitField3 from "./Portfolio/ApplicationDevelopment/AsitFeild3.png";
import Varn2 from "./Portfolio/WebApp/Varn2.png";
import Varn3 from "./Portfolio/WebApp/Varn3.png";
import EasyGym2 from "./Portfolio/ApplicationDevelopment/EasyGym1.png";
import EasyGym3 from "./Portfolio/ApplicationDevelopment/Easygym2.png";
import FarmHouseHub2 from "./Portfolio/ApplicationDevelopment/FamHouseHub2.png";
import FarmHouseHub3 from "./Portfolio/ApplicationDevelopment/FarmHouseHub3.png";
import GenieDelivery2 from "./Portfolio/ApplicationDevelopment/GenieDelivery2.png";
import GenieDelivery3 from "./Portfolio/ApplicationDevelopment/GenieDelivery3.png";
import OneVision2 from "./Portfolio/ApplicationDevelopment/OneVision2.png";
import OneVision3 from "./Portfolio/ApplicationDevelopment/OnVision3.png";
import Efone2 from "./Portfolio/ApplicationDevelopment/Efone2.png";
import Efone3 from "./Portfolio/ApplicationDevelopment/Efone3.png";
import TeamFlow from "./Portfolio/WebApp/TeamFlow.png";
import TeamFlow2 from "./Portfolio/WebApp/TeamFlow2.png";
import TeamFlow3 from "./Portfolio/WebApp/TeamFlow3.png";
import AddScale from "./Portfolio/WebApp/AddScale.png";
import AddScale2 from "./Portfolio/WebApp/AddScale2.png";
import AddScale3 from "./Portfolio/WebApp/AddScale3.png";
import ReactNative from "./AppDev/ReactNative.png";
import Swift from "./AppDev/Swift.png";
import Kotlin from "./AppDev/Kotlin.png";
import Flutter from "./AppDev/Flutter.png";
import Firebase from "./AppDev/Firebase.png";
import FlutterFlow from "./AppDev/FlutterFlow.png";

const images = {
    client_1,
    client_2,
    client_3,
    client_4,
    client_5,
    client_6,
    client_7,
    client_8,
    hero_2,
    hero_3,
    hero_1,
    company1,
    company2,
    company3,
    company4,
    company5,
    company6,
    company7,
    company8,
    company10,
    google,
    bark,
    clutch,
    GoodFirm,
    sortist,
    work1,
    work2,
    work3,
    work4,
    work5,
    work6,
    certificate1,
    certificate2,
    certificate3,
    certificate4,
    certificate5,
    certificate6,
    certificate7,
    career,
    icon1,
    icon2,
    icon3,
    icon4,
    icon5,
    icon6,
    memory1,
    memory2,
    memory3,
    memory4,
    memory5,
    memory6,
    memory7,
    webHero,
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    contactUs,
    blog,
    portfolioBg,
    Project1,
    Project2,
    Project3,
    applicationBg,
    portfolioBackground,
    application1,
    application2,
    application3,
    Header,
    Footer,
    WebProject1,
    WebProject2,
    WebProject3,
    AppProject1,
    AppProject2,
    AppProject3,
    NymbleUp1,
    NymbleUp2,
    NymbleUp3,
    FarmHouseHub,
    FarmHouseHub2,
    FarmHouseHub3,
    EasyGym,
    GenieDelivery,
    GenieDelivery2,
    GenieDelivery3,
    OneVision,
    OneVision2,
    OneVision3,
    Efone,
    Efone2,
    Efone3,
    AsitField2,
    AsitField3,
    EasyGym2,
    EasyGym3,
    Varn2,
    Varn3,
    TeamFlow,
    TeamFlow2,
    TeamFlow3,
    AddScale,
    AddScale2,
    AddScale3,
    ReactNative,
    Swift,
    Kotlin,
    Flutter,
    Firebase,
    FlutterFlow,
}

export default images;